export default __webpack_public_path__ + "locales/sq-AL/People.json?hash=4a4d553907c464883e4d8cd0945c4038";